import { userConstants } from '../constants/user.constants';

export function getRoleLabel(role) {
    switch(role) {
        case userConstants.ROLE_ADMIN: return 'Administrador'; 
        case userConstants.ROLE_MANAGER: return 'Gestor'; 
        case userConstants.ROLE_USER: return 'Usuário'; 
        case userConstants.ROLE_APPROVER: return 'Aprovador'; 
        case userConstants.ROLE_SERVICE_DESK: return 'Service Desk';
        case userConstants.ROLE_AUDIT: return 'Auditor';
        default: return '';
    }
}

export function getBlockModeLabel(mode) {
    switch(mode) {
        case userConstants.BLOCK_MODE_AUTO: return 'Automático'; 
        case userConstants.BLOCK_MODE_ENABLED: return 'Ativado'; 
        case userConstants.BLOCK_MODE_DISABLED: return 'Desativado'; 
        case userConstants.BLOCK_MODE_NOT_CONFIGURED: return 'Não Alterar';
        default: return '';
    }
}

export function getJourneyModeLabel(mode) {
    switch(mode) {
        case userConstants.JOURNEY_MODE_FLEXIBLE: return 'Flexível'; 
        case userConstants.JOURNEY_MODE_RIGID: return 'Rígido';         
        case userConstants.JOURNEY_MODE_NOT_CONFIGURED: return 'Não Alterar';
        default: return '';
    }
}

export function getTrileanLabel(mode) {
    switch(mode) {
        case userConstants.TRILEAN_TRUE: return 'Sim'; 
        case userConstants.TRILEAN_FALSE: return 'Não';         
        case userConstants.TRILEAN_NOT_CONFIGURED: return 'Não Alterar';
        default: return '';
    }
}

export function getWorkStatusLabel(status) {
    switch(status) {
        case userConstants.WORK_STATUS_ACTIVE: return 'Trabalhando'; 
        case userConstants.WORK_STATUS_ABSENT: return 'Afastado';                 
        default: return '';
    }
}

export function getAuthActionLabel(action) {
    switch(action) {
        case 1: return 'Login';
        case 2: return 'Senha Incorreta';
        case 3: return 'Usuário Incorreto';
        case 4: return 'Usuário Inativo';
        case 5: return 'Erro';
        
    }
    return action;
}

export function getAuthProviderLabel(provider) {
    switch (provider) {
        case 1: return 'Local';
        case 2: return 'OpenID';
        case 3: return 'LDAP';
    }
    return provider;
}